(function(angular, module) {var deleteItemController, state, stateConfig;

deleteItemController = function($state, ChangeLogService, changeLogItem) {
  'ngInject';
  this.item = changeLogItem;
  console.log(this.item.title);
  this.confirm = function() {
    return ChangeLogService["delete"](changeLogItem).then(function() {
      return $state.go('changeLog.list');
    });
  };
};

state = {
  url: '/delete',
  templateUrl: 'changeLog/delete',
  controllerAs: 'ctrl',
  controller: deleteItemController
};

stateConfig = function($stateProvider) {
  'ngInject';
  $stateProvider.state('changeLog.item.delete', state);
};

module.config(stateConfig);
})(angular, angular.module("changeLog"));